module.exports = __webpack_public_path__ + "static/media/blog9_big.d82bb441.webp";